import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
} from "@mui/material";

const ConfirmationDialog = ({
    open,
    handleClose,
    handleConfirm,
    actionButtonName,
    title,
    description,
}) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{
                sx: { borderRadius: "3px", padding: "8px" },
            }}
        >
            <DialogTitle
                sx={{ display: "flex", alignItems: "center", gap: 1.5, pb: 1 }}
            >
                <Typography variant="h6" component="span" fontWeight="600">
                    {title || "Discard changes?"}
                </Typography>
            </DialogTitle>

            <DialogContent>
                <DialogContentText
                    sx={{ color: "text.secondary", fontSize: "0.95rem" }}
                >
                    {description ||
                        "This action will clear all information you’ve entered. This cannot be undone."}
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button
                    onClick={handleClose}
                    sx={{ color: "text.secondary", fontWeight: "bold" }}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={handleConfirm}
                    color="error"
                    disableElevation
                    sx={{
                        borderRadius: "8px",
                        px: 3,
                        fontWeight: "bold",
                        textTransform: "none",
                    }}
                >
                    {actionButtonName || "Discard"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
